import type { ActivityEntry } from 'shared/src/api/activity-feed-api-types';
import { isCampaignCentricActivityType } from './activity-card-meta';

export function isMutedActor(entry: ActivityEntry): boolean {
  return (
    entry.actorSource === 'zoho' ||
    entry.actorSource === 'platform' ||
    entry.actorName === 'Zoho Sync' ||
    entry.actorName === 'Zoho'
  );
}

export function getActorDisplayName(entry: ActivityEntry): string {
  if (entry.actorName) return entry.actorName;
  if (entry.actorSource === 'zoho') return 'Zoho';
  if (entry.actorSource === 'platform') return 'Platform Sync';
  return 'System';
}

export function shouldRenderSubtitle(entry: ActivityEntry, showCampaignName: boolean): boolean {
  if (!showCampaignName) return false;
  if (isCampaignCentricActivityType(entry.activityType)) return false;
  if (entry.campaignId == null) return false;
  return true;
}

export function shouldLinkLineItemTitle(entry: ActivityEntry): boolean {
  return (
    entry.activityType === 'line_item_change' &&
    !!entry.campaignId &&
    !!entry.lineItemId &&
    !!entry.entityName
  );
}

export function buildActivityCardAriaLabel({
  typeLabel,
  entityName,
  actorDisplayName,
  absoluteTimestamp
}: {
  typeLabel: string;
  entityName: string | null;
  actorDisplayName: string;
  absoluteTimestamp: string;
}): string {
  const entity = entityName ?? 'activity';
  return `${typeLabel} on ${entity} by ${actorDisplayName} at ${absoluteTimestamp}`;
}
